<a *ngIf="!isLoggedIn()" routerLink="/login">Logga in</a>
<a *ngIf="isLoggedIn()" routerLink="/account">
    <mat-icon inline aria-hidden="true" fontSet="material-icons-outlined">person</mat-icon>
    {{getName()}}
</a>
<a *ngIf="isLoggedIn()" id="logout-s2-button" class="logout" (click)="logOut()">Logga ut</a>